import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import * as fileActions from '../fileActions';import valueFilters from '../valueFilters';
import globalRelay from '../globalRelay';
import componentServices from '../componentServices';
import { Confirm, Expander, FileList, SearchForm, Spinner } from './sharedComponents';
import { getCollection, ModelCollection } from 'Scripts/store';

const _searchKey = 'scan-management-jobs-search';

class ScanManagementModule extends React.Component<any,any> {
	private _fetchingFiles;
	private _searchParameters;

	constructor (props) {
		super(props);

		this._fetchingFiles = false;

		this.deleteFile = this.deleteFile.bind(this);

		this._searchParameters = globalRelay.config!.search.params[_searchKey];
	}

	deleteFile (file) {
		const deleter = () => {
			fileActions.deleteFile({ file: file });
			actions.popModal();
		};
		const title = `Delete ${file.name}?`;

		actions.pushModal({
			component: <Confirm title={title} message="Are you sure you want to delete this file?" confirmLabel="Yes" cancelLabel="No" cancelHandler={ actions.popModal } confirmHandler={ deleter } />
		});
	}

	onSearch (searchState) {
		const searchText = valueFilters.clean(searchState.searchText);
		const params:any = {};
		let canceled = false;
		const cancelAction = () => {
			canceled = true;
			actions.deleteModal({ key: _searchKey });
		};

		actions.pushModal({ key: _searchKey, component: (<Spinner cancelAction={cancelAction}/>) });

		params.job = { accountingId: searchText };

		fileActions.fetchFilesForJob(params).then(result => {
			if (!canceled) {
				if (result && result.files && result.files.length) {
					actions.setSearchResults({ key: _searchKey, searchParameter: searchState.searchParameter, searchText: searchText, fileKeys: _.map(result.files, f => f.key) });
				}
				else {
					actions.setSearchResults({ key: _searchKey, searchParameter: searchState.searchParameter, searchText: searchText, fileKeys: []});
				}
			}
		}).finally(() => {
			cancelAction();
		});
	}

	onSearchCleared () {
		actions.deleteSearchResults({ key: _searchKey });
	}

	render () {
		const { store } = componentServices;
		const searchResults = store.getIn(['viewState', 'searchResults', _searchKey]);
		const fileKeys = (searchResults && searchResults.fileKeys) || [];
		const jobFiles = getCollection({ store, collection: ModelCollection.files }).filter(f => {
			return f.source === 'scan' && fileKeys.indexOf(f.key) !== -1;
		}).toArray();
		const titleSection = "Scanned Documents";

		return (
			<div className="dashboard">
				<SearchForm
					onSearch={this.onSearch}
					onSearchCleared={ this.onSearchCleared }
					searchParameters={ this._searchParameters }
					initialSearchText={ searchResults && searchResults.searchText }
					initialActiveParameter={ searchResults && searchResults.searchParameter }
					searchTextTest={ /[\w\d]{3}/ } />
				<Expander title= {titleSection}>
					<FileList list={ jobFiles } emptyTitle = { `No ${titleSection}`} deleteFile={ this.deleteFile } />
				</Expander>
			</div>
		);
	}
}

componentServices.router.addRoutes([{
	path: '/scan-management',
	component: ScanManagementModule,
	contentClass: '',
	onEnter: componentServices.router.requireUser(componentServices.router.requireModule('scan-management'))
}]);

export default ScanManagementModule;